import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { componentsReducer, orbitaReducer } from './reducers';

const appReducers = combineReducers({ orbita: orbitaReducer, components: componentsReducer });

export default createStore(appReducers, composeWithDevTools(applyMiddleware(thunk)));
